import Analytics from 'analytics';
import googleAnalytics from '@analytics/google-analytics';

declare const __ANALYTICS_MEASUREMENT_ID__: string;

const initAnalytics = (measurementIds: string[]) =>
  Analytics({
    app: 'planne-widgets',
    plugins: [
      googleAnalytics({
        measurementIds: measurementIds,
        gtagName: 'gtagPlanneWidgets',
      }),
    ],
  });

export const analytics = initAnalytics([__ANALYTICS_MEASUREMENT_ID__]);

export const track = (ev: string, data: any = null) => {
  analytics.track(ev, data);
};

export const identify = (id: string, data: any) => {
  analytics.identify(id, data);
};

export const reset = () => {
  analytics.reset();
};

export default {
  track,
  identify,
  reset,
  analytics,
};
